import {
    Description,
    // FileDownload,
    FileUpload,
    ModeEdit,
    TextSnippet,
} from '@mui/icons-material';
import { Box, Button, Menu, MenuItem, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
    useMemo,
    // useRef,
    useState,
} from 'react';
import { toast } from 'react-toastify';
// import AppUserGuide from 'components/new_components/AppUserGuide';
// import { steps } from './steps';

// core components
import AppButton from 'components/new_components/AppButton';
// import AppUploadButton from 'components/new_components/AppUploadButton';
import ItemSubheader from '../ItemSubheader';
// import DocumentDrawer from './DocumentDrawer';

// redux
import { connect, useDispatch, useSelector } from 'react-redux';
import { ExemptMerchantDocument, UploadMerchantDocument } from 'store/actions/complianceActions';

// utils
import Dash from 'assets/img/Dash.svg';
// import FileUnCheck from 'assets/img/FileUncheck.svg';
// import Download from 'assets/img/download01.svg';
// import { accept } from 'validate';
// import { getResourceDetailsByStandard } from '../../utils';

// import { UserGuideContext } from 'store/context/UserGuideContextProvider';

//translations
// import LoadingState from 'components/new_components/LoadingState';
import { useTranslation } from 'react-i18next';
// import { GetDocumentLink } from 'store/actions/complianceActions';
import { saveAs } from 'file-saver';
import { GetDocumentLink } from 'store/actions/complianceActions';
import { getFile } from 'store/actions/editorActions';
import { getType } from 'utils';
// import PolicyHistoryModal from '../PolicyHistoryModal';
// import UploadDocumentModal_two from '../UploadDocumentModal_two';
import AcceptanceHistoryDrawer from './editor/components/AcceptanceHistoryDrawer';
import CustomTooltip from './editor/components/CustomTooltip';
import PolicyEditorDrawer from './editor/components/PolicyEditorDrawer';
import PolicyHistoryDrawer from './editor/components/PolicyHistoryDrawer';
import UploadDocumentDrawer from './editor/components/UploadDocumentDrawer';
import { extractDocName } from './editor/utils';

// const { pdf, docx, excel, txt, ppt } = accept;

const DocumentItem = (props) => {
    const {
        document,
        all_merchant_documents,
        title_key,
        // UploadMerchantDocument,
        ExemptMerchantDocument,
        standard,
        onResourceChange,
        // userguide_info,
        openTaskAssignModal,
        resource,
        taskInfo,
        assignedDocuments,
        // openPolicyHistory,
        // handleOpenPolicyHistory,
        // handleClosePolicyHistory,
    } = props;
    const theme = useTheme();
    // state
    const [loading, setLoading] = useState({ upload: false, exempt: false });
    // const [drawerOpenedTab, setDrawerOpenedTab] = useState(null);
    // const [uploadDocumentModal, setUploadDocuementModal] = useState(false);
    // const [loadingLink, setLoadingLink] = useState(false);
    // const [openUserGuide, setOpenUserGuide] = useState(false);
    const [isPolicyEditorDrawerOpen, setIsPolicyEditorDrawerOpen] = useState(false);
    const [isUploadDocumentDrawerOpen, setIsUploadDocumentDrawerOpen] = useState(false);
    const [isAcceptanceHistoryDrawerOpen, setIsAcceptanceHistoryDrawerOpen] = useState(false);
    const [isPolicyHistoryDrawerOpen, setIsPolicyHistoryDrawerOpen] = useState(false);
    const [updateAnchorEl, setUpdateAnchorEl] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const user_id = useSelector((state) => state?.authReducers?.user_id);
    const raw_all_employees = useSelector((state) => state?.generalReducers?.all_employees);

    const dispatch = useDispatch();

    const role = getType('role');
    //translation
    const { t } = useTranslation('compliance');

    // ref
    // const inputRef = useRef();
    // const stepsTargetRef = useRef([]);

    // const openUploadModal = () => {
    //     setUploadDocuementModal(true);
    // };

    // const closeUploadModal = () => {
    //     setUploadDocuementModal(false);
    // };

    // const { updateOneUserGuide } = useContext(UserGuideContext);

    // memo
    // get the current document in view
    const all_employees = useMemo(
        () =>
            raw_all_employees?.map((employee) => ({
                ...employee,
                name: employee?.user_detail?.first_name
                    ? `${employee?.user_detail?.first_name} ${employee?.user_detail?.last_name}`
                    : employee?.user_detail?.email,
            })),
        [raw_all_employees]
    );

    const selectedDocument = useMemo(() => {
        return all_merchant_documents
            ?.sort((a, b) => b?.id - a?.id)
            ?.find((doc) => doc?.document_id === document?.id && doc?.current);
    }, [document, all_merchant_documents]);

    const isDocEditorDocument = useMemo(() => {
        const docExtension = (selectedDocument?.filename || selectedDocument?.document || document?.default)
            ?.split('.')
            .pop();
        return ['pdf', 'docx'].includes(docExtension);
    }, [document, selectedDocument]);

    const isCurrentUserDocApprover = useMemo(() => {
        return selectedDocument?.approved_by === user_id && selectedDocument?.approved_status === 'pending';
    }, [user_id, selectedDocument]);

    const approvedByName = useMemo(() => {
        const approver = all_employees?.find((employee) => employee?.user_detail?.id === selectedDocument?.approved_by);
        return approver ? approver.name : 'N/A';
    }, [all_employees, selectedDocument]);

    // logic
    // const openDrawer = (tab) => setDrawerOpenedTab(tab);
    // const closeDrawer = () => setDrawerOpenedTab(null);

    //UserGuide
    // const OpenUserGuide = () => {
    //     setOpenUserGuide(true);
    // };
    // const CloseUserGuide = () => {
    //     updateOneUserGuide({ compliance: true });
    //     setOpenUserGuide(false);
    // };

    // async functions
    // update a document version
    // const uploadMerchantDocument = async (e) => {
    //     // get the form data
    //     const doc = new FormData();
    //     doc.append('document', e.target.files[0]);
    //     doc.append('document_id', document?.id);

    //     // sending the data
    //     setLoading({ ...loading, upload: true });
    //     const res = await UploadMerchantDocument(doc);
    //     setLoading({ ...loading, upload: false });
    //     //handling response
    //     if (res?.success) {
    //         toast.success(res?.message);
    //         if (standard !== 'tech_sec') {
    //             onResourceChange();
    //         }
    //     } else {
    //         toast.error(res?.message);
    //     }
    //     inputRef.current.value = null;
    // };
    // exempt a document
    const exemptMerchantDocument = async () => {
        const payload = {
            document: document?.id,
            standard,
        };
        setLoading({ ...loading, exempt: true });
        const res = await ExemptMerchantDocument(payload);
        setLoading({ ...loading, exempt: false });
        if (res?.success) {
            toast.success(res?.message);
            onResourceChange();
        } else {
            toast.error(res?.message);
        }
    };
    const newMenuitems_user = [
        !assignedDocuments?.includes(document?.id) &&
            role !== 'auditor' && {
                label: 'Assign to',
                action: () =>
                    openTaskAssignModal(resource, {
                        standard: standard === 'iso22301' ? 'is022301' : standard,
                        document: document?.id,
                        is_document: true,
                        ...taskInfo,
                    }),
            },
        { label: 'View policy history', action: () => setIsPolicyHistoryDrawerOpen(true) },
        { label: 'View acceptance history', action: () => setIsAcceptanceHistoryDrawerOpen(true) },
    ];
    const newMenuitems_auditor = [
        { label: 'View policy history', action: () => setIsPolicyHistoryDrawerOpen(true) },
        { label: 'View acceptance history', action: () => setIsAcceptanceHistoryDrawerOpen(true) },
    ];
    const newMenuitems = role === 'auditor' ? newMenuitems_auditor : newMenuitems_user;

    // const getDocumentLink = async () => {
    //     setLoadingLink(true);
    //     const res = await dispatch(GetDocumentLink('document', document?.id));
    //     setLoadingLink(false);
    //     if (res?.success) {
    //         window.open(res?.data, '_blank');
    //     } else {
    //         toast.error('Something went wrong!');
    //     }
    // };

    async function getDocumentLink() {
        try {
            setIsLoading(true);

            const authorizedUrlResponse = await dispatch(GetDocumentLink('document', document?.id));
            if (!authorizedUrlResponse?.success) {
                throw new Error('Failed to get authorized document link');
            }

            const fileResponse = await dispatch(getFile(authorizedUrlResponse?.data));
            if (!fileResponse?.success) {
                throw new Error(fileResponse?.message);
            }

            saveAs(fileResponse?.blob, extractDocName(document?.default)?.replaceAll('_', ' '));
        } catch (error) {
            toast.error(error?.message || 'Something went wrong!');
        } finally {
            setIsLoading(false);
        }
    }

    // console.log({
    //     document,
    //     all_merchant_documents,
    //     selectedDocument,
    //     title_key,
    //     standard,
    //     resource,
    //     taskInfo,
    //     assignedDocuments,
    // });

    return (
        <Box sx={{ p: 2, py: 4 }}>
            <ItemSubheader
                hasResource={Boolean(selectedDocument)}
                approverPending={selectedDocument?.approved_status === 'pending' && selectedDocument?.approved_by}
                approvedByName={approvedByName}
                reviewPending={selectedDocument?.approved_status === 'pending_review'}
                exempting={loading.exempt}
                onExempt={exemptMerchantDocument}
                menuItems={
                    standard === 'soc2' || standard === 'sslc' || standard === 'iso9001' || standard === 'iso20000'
                        ? newMenuitems
                        : [
                              { label: t('document'), action: () => setIsPolicyHistoryDrawerOpen(true) },
                              {
                                  label: 'View acceptance history',
                                  action: () => setIsAcceptanceHistoryDrawerOpen(true),
                              },
                              ...(!assignedDocuments?.includes(document?.id) &&
                              role !== 'auditor' &&
                              standard !== 'isms' &&
                              standard !== 'tech_sec'
                                  ? [
                                        {
                                            label: 'Assign to',
                                            action: () =>
                                                openTaskAssignModal(resource, {
                                                    standard: standard === 'iso22301' ? 'is022301' : standard,
                                                    document: document?.id,
                                                    is_document: true,
                                                    ...taskInfo,
                                                }),
                                        },
                                    ]
                                  : []),
                              // { label: 'Comments', action: () => openDrawer(1) },
                          ]
                }
                assigned={assignedDocuments?.includes(document?.id)}
                resource="doc"
                standard={standard}
            />
            <Stack direction={'column'} justifyContent="flex-start" alignItems="flex-start" sx={{ py: 2 }} spacing={3}>
                {standard === 'soc2' || standard === 'sslc' || standard === 'iso9001' || standard === 'iso20000' ? (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <img src={Dash} alt="Dash" />

                        <Typography
                            sx={{
                                color: '#475569',
                                fontWeight: 500,
                                fontSize: 15,
                                ml: 1,
                            }}
                        >
                            {t(selectedDocument ? 'uploadUpdate' : 'upload')} {document?.[title_key]}.
                            {(selectedDocument?.filename || selectedDocument?.document || document?.default)
                                ?.split('.')
                                .pop()}
                        </Typography>
                    </Box>
                ) : (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <TextSnippet color="primary" />

                        <Typography
                            sx={{
                                color: '#475569',
                                fontWeight: 500,
                                fontSize: 15,
                                ml: 1,
                            }}
                        >
                            {t(selectedDocument ? 'uploadUpdate' : 'upload')} {document?.[title_key]}.
                            {(selectedDocument?.filename || selectedDocument?.document || document?.default)
                                ?.split('.')
                                .pop()}
                        </Typography>
                    </Box>
                )}
                <Stack>
                    {(standard !== 'soc2' && standard !== 'sslc') ||
                        ((standard === 'iso9001' || standard === 'iso20000') && (
                            <Typography
                                sx={{
                                    color: theme.palette.gray[800],
                                    fontWeight: 500,
                                    fontSize: 16,
                                }}
                            >
                                {t(selectedDocument ? 'uploadUpdate' : 'upload')} {document?.[title_key]}.
                                {(selectedDocument?.filename || selectedDocument?.document || document?.default)
                                    ?.split('.')
                                    .pop()}
                            </Typography>
                        ))}
                    {(standard !== 'soc2' && standard !== 'sslc') ||
                        ((standard === 'iso9001' || standard === 'iso20000') && (
                            <Typography
                                sx={{
                                    color: theme.palette.gray[500],
                                    fontWeight: 500,
                                    fontSize: 12,
                                }}
                            >
                                {t('click')}
                            </Typography>
                        ))}
                    {/* {standard === 'soc2' || standard === 'sslc' || standard === 'iso9001' || standard === 'iso20000' ? (
                        <Box sx={{ ml: 1.8, mt: -1 }}>
                            <Button
                                variant="outlined"
                                sx={{
                                    textTransform: 'inherit',
                                    color: '#64748B',
                                    border: '2px solid #395BA9',
                                    width: 'inherit',
                                    textAlign: 'left',
                                    display: 'flex',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                    '&, &:hover': { color: '#64748B', border: '2px solid #395BA9' },
                                }}
                                disabled={role === 'auditor'}
                                onClick={openUploadModal}
                                startIcon={<img src={FileUnCheck} alt="FileUnCheck" />}
                            >
                                {selectedDocument ? t('uploadVersion') : t('uploadDocument')}
                            </Button>

                            <AppButton
                                color="primary"
                                variant="text"
                                name={loadingLink ? <LoadingState size={20} /> : 'Download policy template'}
                                icon={<img src={Download} alt="Download" className="w-4" />}
                                disabled={role === 'auditor'}
                                onClick={getDocumentLink}
                                download
                                sx={{
                                    textTransform: 'inherit',
                                    color: '#64748B',
                                    textDecoration: 'underline',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                    ml: -2,
                                    mt: 0.5,
                                    '&, &:hover': { color: '#64748B' },
                                }}
                                ref={(el) => (stepsTargetRef.current[0] = el)}
                            />
                        </Box>
                    ) : (
                        <Stack direction="row" spacing={3}>
                            <AppButton
                                color="primary"
                                variant="contained"
                                name={loadingLink ? <LoadingState size={20} /> : t('downloadTemplate')}
                                icon={<FileDownload />}
                                onClick={getDocumentLink}
                                disabled={role === 'auditor'}
                                sx={{
                                    textTransform: 'uppercase',
                                    '&, &:hover': { color: theme.palette.white.main },
                                }}
                                ref={(el) => (stepsTargetRef.current[0] = el)}
                            />
                            <AppUploadButton
                                color="primary"
                                variant="outlined"
                                label={selectedDocument ? t('uploadVersion') : t('uploadDocument')}
                                startIcon={<FileUpload />}
                                loading={loading.upload}
                                id={document?.[title_key]}
                                onChange={uploadMerchantDocument}
                                disabled={role === 'auditor'}
                                accept={`${pdf},${docx},${excel},${txt},${ppt}`}
                                sx={{ textTransform: 'uppercase' }}
                                inputRef={inputRef}
                                ref={(el) => (stepsTargetRef.current[1] = el)}
                                />
                                </Stack>
                                )} */}

                    <Stack direction="row" spacing={2} alignItems={'center'}>
                        {selectedDocument ? (
                            <div>
                                <AppButton
                                    color="primary"
                                    variant="contained"
                                    name={'Update document'}
                                    icon={<ModeEdit />}
                                    disabled={role === 'auditor'}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        setUpdateAnchorEl(event.currentTarget);
                                    }}
                                    sx={{
                                        textTransform: 'uppercase',
                                        '&, &:hover': { color: theme.palette.white.main },
                                    }}
                                />

                                <Menu
                                    anchorEl={updateAnchorEl}
                                    open={Boolean(updateAnchorEl)}
                                    onClose={(event) => {
                                        event.stopPropagation();
                                        setUpdateAnchorEl(null);
                                    }}
                                    sx={{
                                        '& .MuiPaper-root': {
                                            borderRadius: '4px',
                                            boxShadow:
                                                '4px 4px 8px rgba(175, 172, 172, 0.15), -4px -4px 8px rgba(175, 172, 172, 0.15)',
                                        },
                                        '& .MuiList-root': {
                                            padding: '0 0',
                                            width: '199px',
                                        },
                                    }}
                                >
                                    <MenuItem
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            setUpdateAnchorEl(null);
                                            setIsPolicyEditorDrawerOpen(true);
                                        }}
                                        sx={{
                                            color: '#64748B',
                                            fontWeight: 500,
                                            fontSize: '14px',
                                            textTransform: 'none',
                                            padding: '8px 16px',
                                            border: '1px solid #F1F5F9',
                                        }}
                                        disabled={!isDocEditorDocument}
                                    >
                                        Use live editor
                                    </MenuItem>

                                    <MenuItem
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            setUpdateAnchorEl(null);
                                            setIsUploadDocumentDrawerOpen(true);
                                        }}
                                        sx={{
                                            color: '#64748B',
                                            fontWeight: 500,
                                            fontSize: '14px',
                                            textTransform: 'none',
                                            padding: '8px 16px',
                                            border: '1px solid #F1F5F9',
                                        }}
                                    >
                                        Upload from device
                                    </MenuItem>
                                </Menu>
                            </div>
                        ) : (
                            <>
                                {isDocEditorDocument ? (
                                    <Button
                                        variant="outlined"
                                        sx={{
                                            textTransform: 'inherit',
                                            color: '#64748B',
                                            border: '1px solid #E2E8F0',
                                            width: 'inherit',
                                            textAlign: 'left',
                                            display: 'flex',
                                            justifyContent: 'left',
                                            alignItems: 'left',
                                            '&, &:hover': { color: '#64748B', border: '1px solid #395BA9' },
                                        }}
                                        disabled={role === 'auditor'}
                                        onClick={() => {
                                            setIsPolicyEditorDrawerOpen(true);
                                        }}
                                        startIcon={<FileUpload />}
                                    >
                                        Use template editor
                                    </Button>
                                ) : (
                                    <CustomTooltip
                                        title="You can’t use the template editor because it only supports .DOCX and PDF files for now"
                                        placement="bottom"
                                        width="176px"
                                    >
                                        <Button
                                            variant="outlined"
                                            sx={{
                                                textTransform: 'inherit',
                                                color: '#64748B',
                                                border: '1px solid #E2E8F0',
                                                width: 'inherit',
                                                textAlign: 'left',
                                                display: 'flex',
                                                justifyContent: 'left',
                                                alignItems: 'left',
                                                cursor: 'not-allowed !important',
                                                opacity: 0.6,
                                                '&, &:hover': { color: '#64748B', border: '1px solid #395BA9' },
                                            }}
                                            startIcon={<FileUpload />}
                                        >
                                            Use template editor
                                        </Button>
                                    </CustomTooltip>
                                )}

                                <Typography
                                    sx={{
                                        color: '#475569',
                                        fontWeight: 500,
                                        fontSize: 15,
                                    }}
                                >
                                    OR
                                </Typography>

                                <Button
                                    variant="outlined"
                                    sx={{
                                        textTransform: 'inherit',
                                        color: '#64748B',
                                        border: '1px solid #E2E8F0',
                                        width: 'inherit',
                                        textAlign: 'left',
                                        display: 'flex',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                        '&, &:hover': { color: '#64748B', border: '1px solid #395BA9' },
                                    }}
                                    disabled={role === 'auditor'}
                                    onClick={() => {
                                        setIsUploadDocumentDrawerOpen(true);
                                    }}
                                    startIcon={<Description />}
                                >
                                    Upload document
                                </Button>
                            </>
                        )}
                    </Stack>

                    <Stack direction="row" spacing={0.5} alignItems={'center'} mt={2}>
                        {isDocEditorDocument ? (
                            <>
                                <img
                                    src="/img/frameworks/fluent_info-12-filled.svg"
                                    alt="Info Circle"
                                    className="!size-5"
                                />

                                <p className="text-[#334155] text-[13px]">
                                    The template editor only supports .DOCX and PDF files
                                </p>
                            </>
                        ) : (
                            <>
                                {/* <img src="/img/frameworks/file-download.svg" alt="file download" className="!size-4" /> */}

                                <p className="text-[#475569] font-semibold text-[13px]">
                                    Don't have a template for your policy?.{' '}
                                    <span
                                        className="text-[#395BA9] decoration-[#395BA9] underline font-bold cursor-pointer transition-all hover:no-underline disabled:opacity-50 disabled:pointer-events-none"
                                        role="button"
                                        disabled={isLoading}
                                        onClick={() => getDocumentLink()}
                                    >
                                        {isLoading ? 'Downloading...' : 'Download our template'}
                                    </span>
                                </p>
                            </>
                        )}
                    </Stack>
                </Stack>
            </Stack>
            {/* <DocumentDrawer
                open={Boolean(drawerOpenedTab !== null)}
                tab={drawerOpenedTab}
                handleClose={closeDrawer}
                document={getResourceDetailsByStandard(selectedDocument, standard)}
                onResourceChange={onResourceChange}
                standard={standard}
                role={role}
            /> */}
            {/* <AppUserGuide
                open={openUserGuide}
                onClose={CloseUserGuide}
                steps={steps}
                targets={stepsTargetRef.current}
            /> */}
            {/* <UploadDocumentModal_two
                open={uploadDocumentModal}
                handleClose={closeUploadModal}
                doc_id={document?.id}
                standard={standard}
            /> */}
            {/* <PolicyHistoryModal
                open={openPolicyHistory}
                handleClose={handleClosePolicyHistory}
                selected={selectedDocument}
                document={getResourceDetailsByStandard(selectedDocument, standard)}
                doc_id={document?.id}
            /> */}

            <PolicyEditorDrawer
                isOpen={isPolicyEditorDrawerOpen}
                setIsOpen={setIsPolicyEditorDrawerOpen}
                handleCallback={() => {}}
                standard={standard}
                templateId={document?.id}
                document={selectedDocument ? selectedDocument : document}
                role={isCurrentUserDocApprover ? 'approver' : ''}
                isTemplateFile={!selectedDocument}
                filename={
                    selectedDocument
                        ? extractDocName(selectedDocument?.filename || selectedDocument?.document)?.replaceAll('_', ' ')
                        : extractDocName(document?.default?.replaceAll('_', ' '))
                }
            />

            <UploadDocumentDrawer
                isOpen={isUploadDocumentDrawerOpen}
                setIsOpen={setIsUploadDocumentDrawerOpen}
                standard={standard}
                template={document}
                templateId={document?.id}
                existingPolicyId={selectedDocument ? selectedDocument?.id : null}
            />

            <PolicyHistoryDrawer
                isOpen={isPolicyHistoryDrawerOpen}
                setIsOpen={setIsPolicyHistoryDrawerOpen}
                templateId={document?.id}
                title={document?.[title_key]}
            />

            <AcceptanceHistoryDrawer
                isOpen={isAcceptanceHistoryDrawerOpen}
                setIsOpen={setIsAcceptanceHistoryDrawerOpen}
                templateId={document?.id}
                title={document?.[title_key]}
            />
        </Box>
    );
};

const mapStateToProps = (state) => {
    return {
        all_merchant_documents: state?.complianceReducers?.all_merchant_documents,
        // userguide_info: state?.guideReducers?.userguide_info?.[0]?.compliance,
    };
};
export default connect(mapStateToProps, {
    UploadMerchantDocument,
    ExemptMerchantDocument,
})(DocumentItem);
